import React from 'react';
import { FC } from 'react';
import { Minus, Plus, Quantity, Wrapper } from './Quantity.element';

export interface QuantityProps {
    quantity: number;
    setPlusQuantity: Function;
    setMinusQuantity: Function;
}

const QuantityTemplate: FC<QuantityProps> = ({ quantity, setPlusQuantity, setMinusQuantity }) => {
    return (
        <Wrapper>
            <Minus onClick={() => setMinusQuantity()}>-</Minus>
            <Quantity>{quantity}</Quantity>
            <Plus onClick={() => setPlusQuantity()}>+</Plus>
        </Wrapper>
    );
};

export default QuantityTemplate;
